/**
 * mrApi Vue Plugin
 *
 * This plugin installs an $mrApi property on the Vue object as a reference
 * to the mrApi module. Components that were using $http via the Vue-Axios
 * module via 'Vue.$http' may use this instead for requests to mr website server.
 */

function plugin(app, mrApi) {
  if (!mrApi) {
    console.error('mrApi is required.');
    return;
  }

  if (!mrApi.get || !mrApi.post) {
    console.log('Invalid mrApi interface.');
    return;
  }

  // Add $mrApi to the global properties
  app.config.globalProperties.$mrApi = mrApi;

  // Optionally, provide it so it can be injected in components
  app.provide('$mrApi', mrApi);
}

export default {
  install: (app, options) => {
    plugin(app, options);
  }
};
